import * as actions from '../actions/manageSolicitorAccount';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function getAcceptedToba(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_ACCEPTED_TOBA)
        .map(action => ({
            url: BASE_URL + 'api/toba/toba/' + action.payload,
            category: 'getAcceptedToba',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getAcceptedToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetAcceptedToba(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function getAcceptedTobaFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('getAcceptedToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.requestGetAcceptedTobaFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function getLawsysDetails(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_LAWSYS_DETAILS)
        .map(action => ({
            url: BASE_URL + 'api/users/GetLawsysAgent/' + action.payload,
            category: 'getLawsysDetails',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens for for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the logged in user
    let httpResponse$ = sources.HTTP
        .select('getLawsysDetails')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetLawsysDetails(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedToReceiveLawsysDetails(sources) {
    let httpResponse$ = sources.HTTP
        .select('getLawsysDetails')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveFailedResponseGetLawsysDetails(response))

    return {
        ACTION: httpResponse$
    };
}
export function getSolicitorDetails(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITOR_DETAILS)
        .map(action => ({
            url: BASE_URL + 'api/users/solicitors/' + action.payload,
            category: 'getSolicitorDetails',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens for for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the logged in user
    let httpResponse$ = sources.HTTP
        .select('getSolicitorDetails')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetSolicitorDetails(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedToReceiveSolicitorDetails(sources) {
    let httpResponse$ = sources.HTTP
        .select('getSolicitorDetails')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveFailedResponseGetSolicitorDetails(response))

    return {
        ACTION: httpResponse$
    };
}

export function updateSolicitorDetails(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_UPDATE_SOLICITOR_DETAILS)
        .map(action => ({
            url: BASE_URL + 'api/users/solicitors/' + action.payload.userId,
            category: 'putSolicitor',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('putSolicitor')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveUpdateSolicitorResponse(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function badResponseUpdateSolicitor(sources) {
    let httpResponse$ = sources.HTTP
        .select('putSolicitor')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadResponseUpdateSolicitor(response.response.body.message));

    return {
        ACTION: httpResponse$,
    };
}

export function updateSolicitorPassWord(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_UPDATE_SOLICITOR_PASSWORD)
        .map(action => ({
            url: BASE_URL + 'api/users/solicitors/' + action.payload.userId,
            category: 'putSolicitorPass',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('putSolicitorPass')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveUpdateSolicitorPasswordResponse(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function badResponseUpdateSolicitorPassword(sources) {
    let httpResponse$ = sources.HTTP
        .select('putSolicitorPass')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadResponseUpdateSolicitorPassword(response.response.body.message));

    return {
        ACTION: httpResponse$,
    };
}